module.exports = __webpack_public_path__ + "media/hyper/images/products/product-6-65914d4b1068a68eabd21f52d7d65cd7.jpg";